import { InputNumber, InputNumberChangeEvent, InputNumberProps } from 'primereact/inputnumber';
import { classNames } from 'primereact/utils';
import React from 'react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

type RHFInputNumberProps = {
    control: Control<any>;
    name: string;
    rules?: RegisterOptions;
    disabled?: boolean;
    placeholder?: string;
    inputProps?: InputNumberProps;
};

export const RHFInputNumber = ({ control, name, rules, disabled, placeholder, inputProps }: RHFInputNumberProps) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            disabled={disabled}
            render={({ field, fieldState }) => (
                <InputNumber
                    id={field.name}
                    {...field}
                    ref={undefined}
                    inputRef={field.ref}
                    onChange={(e: InputNumberChangeEvent) => field.onChange(e.value)}
                    className={classNames({ 'p-invalid': fieldState.invalid })}
                    placeholder={placeholder}
                    mode='decimal'
                    showButtons={true}
                    {...inputProps}
                />
            )}
        />
    );
};
